import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import moment from 'moment';

import messages from './locales/es';

// console.log('ES locale:', messages);

const { VUE_APP_I18N_FALLBACK_LOCALE } = process.env;

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'es',
  fallbackLocale: VUE_APP_I18N_FALLBACK_LOCALE || 'es',
});

i18n.setLocaleMessage(i18n.locale, messages);

function setI18nLanguage(lang) {
  i18n.locale = lang;
  moment.locale(lang);
  axios.defaults.headers.common['Accept-Language'] = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

const loadedLanguages = ['es']; // our default language that is preloaded
setI18nLanguage('es');

function loadLanguageAsync(lang) {
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language hasn't been loaded yet
  return import(
    /* webpackChunkName: "lang-[request]" */
    /* webpackMode: "lazy" */
    `./locales/${lang}.js`
  ).then(
    (importedMessages) => {
      i18n.setLocaleMessage(lang, importedMessages.default);
      loadedLanguages.push(lang);
      return setI18nLanguage(lang);
    },
  );
}

export default VueI18n;

export { i18n, loadLanguageAsync };
